
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connect/be-the-panel",
      function () {
        return require("private-next-pages/connect/be-the-panel.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connect/be-the-panel"])
      });
    }
  